import React from "react";
import { Button } from "antd";
import { ReactComponent as FundsIcon } from "../../assets/icons/funds-blue.svg";
import { formatAmount, getUsagePercentage } from "./utils";

const FundsOverview = ({ overview, onBuyFunds }) => {
   const { totalPurchased, totalSpent, funds } = overview;
   const usagePercentage = getUsagePercentage(totalSpent, totalPurchased);

   return (
      <div className="funds__overview">
         <div className="funds__overview-header">
            <h2 className="funds__overview-title">Overview</h2>
            <Button type="primary" className="funds__buy-button" onClick={onBuyFunds}>
               Add funds
            </Button>
         </div>

         <div className="funds__overview-stats">
            <div className="funds__stat">
               <span className="funds__stat-label">Total added</span>
               <span className="funds__stat-value">{formatAmount(totalPurchased)}</span>
            </div>
            <div className="funds__stat">
               <span className="funds__stat-label">Available Balance</span>
               <span className="funds__stat-value">{formatAmount(funds)}</span>
            </div>
         </div>

         <div className="funds__usage">
            <div className="funds__usage-info">
               <span className="funds__usage-label">Usage</span>
               <div className="funds__usage-bar">
                  <div
                     className="funds__usage-bar-fill"
                     style={{ width: `${usagePercentage}%` }}
                  />
               </div>
            </div>
            <div className="funds__usage-count">
               <FundsIcon className="funds__usage-icon" />
               <span>
                  {formatAmount(totalSpent)}/{formatAmount(totalPurchased)}
               </span>
            </div>
         </div>
      </div>
   );
};

export default React.memo(FundsOverview);
